module.exports = __webpack_public_path__ + "img/icon_5_81.24754302.png";